<template>
    <Modal :visible="isModalVisible" @close="closeModal">
        <div
            class="d-flex flex-column align-items-center justify-content-center"
        >
            <i class="fi fi-lock mb-2 text-warning"></i>
            <h2 class="text-center">{{ modalConfig?.title }}</h2>
            <div class="premium-description my-2 w-100 text-center text-muted">
                {{ modalConfig?.message }}
            </div>
            <div class="actions">
                <button
                    class="btn btn-desktop-lg btn-white"
                    @click="closeModal"
                >
                    Maybe Later
                </button>
                <button
                    class="btn btn-desktop-lg btn-primary"
                    @click="goToPlans"
                >
                    {{ modalConfig?.buttonText }}
                </button>
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { goToPlans as navigateToPlans } from '@/utils/navigation';
import { getUserSubscriptionConfig } from '@/utils/subscriptionUiConfig';
import {
    SUBSCRIPTION_STATUS,
    shouldShowPopup,
} from '@/utils/subscriptionStatus';

export default {
    name: 'ReminderModal',
    components: {
        Modal,
    },
    data() {
        return {
            isModalVisible: false,
            STORAGE_KEY: 'ReminderSnooze',
            SNOOZE_DURATION: 2 * 24 * 60 * 60 * 1000, // 2 days
            SHOW_MODAL_DELAY: 5000, // 5 seconds
            timeoutId: null, //store the timeout id for cleanup
        };
    },
    watch: {
        '$userStore.subscriptionDetails': {
            handler(newStatus) {
                if (newStatus) {
                    this.evaluateModalVisibility();
                }
            },
            immediate: true,
        },
    },
    computed: {
        modalConfig() {
            return getUserSubscriptionConfig({
                subscriptionDetails: this.$userStore.subscriptionDetails,
                isCompanyAdmin: this.$userStore.isCompanyAdmin,
                freeTrialEndDateString: this.$permStore.freeTrialEndDateString,
                planName: this.$permStore.getPlanName,
            });
        },
    },
    methods: {
        evaluateModalVisibility() {
            this.clearTimeout();

            if (!this.$userStore.user) {
                this.isModalVisible = false;
                return;
            }

            if (
                this.modalConfig &&
                this.shouldShowReminder() &&
                shouldShowPopup(this.$userStore)
            ) {
                this.showModal();
            } else {
                this.isModalVisible = false;
            }
        },

        showModal() {
            this.clearTimeout();
            this.timeoutId = setTimeout(() => {
                this.isModalVisible = true;
                this.setSnooze();
                this.timeoutId = null;
            }, this.SHOW_MODAL_DELAY);
        },

        clearTimeout() {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
        },

        closeModal() {
            this.isModalVisible = false;
        },

        shouldShowReminder() {
            try {
                const snoozeDuration = localStorage.getItem(this.STORAGE_KEY);
                if (snoozeDuration) {
                    const now = new Date();
                    const snoozeDate = new Date(snoozeDuration);
                    if (snoozeDate > now) {
                        return false;
                    }
                }
                return true;
            } catch (error) {
                console.warn('Error getting snooze duration:', error);
                return true;
            }
        },

        setSnooze() {
            try {
                const snoozeUntil = new Date(Date.now() + this.SNOOZE_DURATION);
                localStorage.setItem(
                    this.STORAGE_KEY,
                    snoozeUntil.toISOString()
                );
            } catch (error) {
                console.warn('Error setting snooze duration:', error);
            }
        },

        goToPlans() {
            const config = this.modalConfig;
            const actionType = config?.actionButtons?.[0]?.actionType || null;

            navigateToPlans(this.$router, { actionType });
            this.closeModal();
        },
    },
    beforeUnmount() {
        this.clearTimeout();
    },
};
</script>

<style scoped>
.premium-description {
    margin-bottom: var(--space-5);
}

.actions {
    display: flex;
    gap: var(--space-2);
    margin-top: var(--space-5);
}

.fi-lock {
    font-size: var(--size-10);
    line-height: var(--size-10);
    font-weight: 200;
}

@media (max-width: 767.98px) {
    .actions {
        flex-direction: column;
        width: 100%;
    }
    .actions .btn {
        width: 100%;
    }
}
</style>
